// If the viewport is wider than 800px, replace the page with a "use your phone" message
// and a static QR code linking back. We deliberately abort all downstream init.

const SITE_URL = "https://wheretopee.lol";

export const DESKTOP_THRESHOLD_PX = 800;

function buildQrSvg(): string {
  // Tiny static placeholder. A real QR encoding for the URL is not strictly required for
  // the message to be useful. Replace with a real QR if needed; keep it inline so we
  // make zero network calls on desktop.
  return `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 33 33" shape-rendering="crispEdges" aria-label="QR code linking to ${SITE_URL}">
    <rect width="33" height="33" fill="#fff"/>
    <g fill="#000">
      <rect x="2" y="2" width="7" height="7"/>
      <rect x="3" y="3" width="5" height="5" fill="#fff"/>
      <rect x="4" y="4" width="3" height="3"/>
      <rect x="24" y="2" width="7" height="7"/>
      <rect x="25" y="3" width="5" height="5" fill="#fff"/>
      <rect x="26" y="4" width="3" height="3"/>
      <rect x="2" y="24" width="7" height="7"/>
      <rect x="3" y="25" width="5" height="5" fill="#fff"/>
      <rect x="4" y="26" width="3" height="3"/>
      <rect x="11" y="11" width="11" height="11"/>
      <rect x="13" y="13" width="7" height="7" fill="#fff"/>
      <rect x="15" y="15" width="3" height="3"/>
    </g>
  </svg>`;
}

export function isDesktopViewport(width: number = window.innerWidth): boolean {
  return width > DESKTOP_THRESHOLD_PX;
}

export function maybeRedirectDesktop(): boolean {
  if (!isDesktopViewport()) return false;

  document.body.innerHTML = "";
  const wrap = document.createElement("div");
  wrap.style.cssText = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
    font-family: system-ui, sans-serif;
    padding: 2rem;
    color: #1f2933;
  `;
  const h1 = document.createElement("h1");
  h1.textContent = "wheretopee is for phones";
  const p = document.createElement("p");
  p.textContent = "Open this link on your phone for the full experience.";
  const url = document.createElement("p");
  const link = document.createElement("a");
  link.href = SITE_URL;
  link.textContent = SITE_URL;
  url.appendChild(link);

  const qr = document.createElement("div");
  qr.innerHTML = buildQrSvg();

  wrap.appendChild(h1);
  wrap.appendChild(p);
  wrap.appendChild(qr);
  wrap.appendChild(url);
  document.body.appendChild(wrap);
  return true;
}
